import React, { FC, ReactNode } from "react";

import { StatsCard } from "./StatsCard";

export type StatsCardsGridItem = {
  id: string;
  label: string;
  value: ReactNode;
  isActive?: boolean;
  isError?: boolean;
  isLoading?: boolean;
};

type Props = {
  items: StatsCardsGridItem[];
};

export const StatsCardsGrid: FC<Props> = ({ items }) => {
  return (
    <div className={"grid grid-cols-5 gap-6 max-md:grid-cols-2 max-md:gap-3"}>
      {items.map((item) => (
        <button key={item.id} type={"button"} className={"cursor-default"}>
          <StatsCard
            cardName={item.label}
            cardCounts={item.value}
            isActive={item.isActive ?? false}
            isError={item.isError}
            isLoading={item.isLoading}
          />
        </button>
      ))}
    </div>
  );
};
